var React = require('react');

function HamburgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.5625 7.875H35.4375V10.5H6.5625V7.875Z","fill":"white","key":0}),React.createElement("path",{"d":"M6.5625 19.6875H35.4375V22.3125H6.5625V19.6875Z","fill":"#E7B607","key":1}),React.createElement("path",{"d":"M6.5625 31.5H35.4375V34.125H6.5625V31.5Z","fill":"white","key":2})]);
}

HamburgerMenu.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = HamburgerMenu;

HamburgerMenu.default = HamburgerMenu;
